import { SegmentType } from "./SegmentType";

export class SegmentStation {

	constructor() {

		this.lat = -1;
		this.lon = -1;
		this.lonlatString = null;
		this.name = null;
		this.uuid = null;

		
		/**
		 * 是否为起始段
		 */
		this.isLinePlanStart=false;

		/**
		 * 是否为终段
		 */
		this.isLinePlanEnd=false;

		/**
		 * 线段类型
		 */
		this.segmentType=null;

		/**
		 * 线段项
		 */
		this.segmentItem=null;
	}


	
	isBusType()
	{	
		if(this.segmentType===SegmentType.Bus)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	isSubwayType()
	{	
		if(this.segmentType===SegmentType.Subway
			|| this.itemType===SegmentType.TransferInSubway)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	static GetSegmentStation(jsonItem) {
		let curItem = null;
		if (jsonItem == null) return curItem;

		curItem = new SegmentStation();

		curItem.lonlatString = jsonItem.lonlat;
		if (curItem.lonlatString) {
			let lonlatSplitInfo = curItem.lonlatString.split(",");
			if (lonlatSplitInfo && lonlatSplitInfo.length == 2) {
				curItem.lat = parseFloat(lonlatSplitInfo[1]);
				curItem.lon = parseFloat(lonlatSplitInfo[0]);
			}
		}

		curItem.name = jsonItem.name;
		curItem.uuid = jsonItem.uuid;

		return curItem;
	}


	static selectBySegmentTypes(stations,segmentTypes)
	{	
		let findStations=new Array();
		if(!stations || !segmentTypes)return findStations;
		

		let tempStation=null;
		let stationType=null;
		for(let stationIndex=0;stationIndex<stations.length;stationIndex++)
		{	
			tempStation=stations[stationIndex];
			stationType=tempStation.segmentType;
			if(stationType && segmentTypes.indexOf(stationType) >-1)
			{
				findStations.push(tempStation);
			}
		}

		return findStations;
	}




}//end SegmentStation

